import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  GlobalMessageType, HttpErrorHandler,
  HttpResponseStatus, Priority
} from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class ForbiddenHandler extends HttpErrorHandler {
  getPriority?(): Priority;

  responseStatus = HttpResponseStatus.BAD_REQUEST;

  handleError(request: HttpRequest<any>, errorResponse: HttpErrorResponse) {
    if (errorResponse.error.hasOwnProperty('errors')) {
      if (errorResponse.error.errors[0].message === 'Invalid entry') {
        return false
      } else if (errorResponse.error.errors[0].message === 'The application has encountered an error') {
        return false
      } else if (errorResponse.error.errors[0].message === 'Cart not found.') {
        return false;
      }
      else if (errorResponse.error.errors[0].message === 'b2bCustomer.register.email.exists') {
        return false;
      }
      else if (errorResponse.error.errors[0].message === 'register.janrain.invalid.password') {
        return false;
      }
      else if (errorResponse.error.errors[0].message === 'This is a secure site for members only. Please try again or call 1-800-822-2463 for assistance.') {
        return false;
      }
      else if(errorResponse.error.errors[0].message === "We couldn't find your customer information in our database. Please call us at 1-800-822-2463.") {
        return false;
      }
      else {
        this.globalMessageService.add(
          errorResponse.error.errors[0].message,
          GlobalMessageType.MSG_TYPE_ERROR
        );
      }
    } else {
      if (errorResponse.error.error_description === 'password_incorrect') {
        this.globalMessageService.add("Username or password is incorrect. Please try again.",
          GlobalMessageType.MSG_TYPE_ERROR);
      } else if (errorResponse.error.error_description === 'no_such_account') {
        this.globalMessageService.add("Sorry, we were unable to verify your username and/or password.",
          GlobalMessageType.MSG_TYPE_ERROR);
      } else if (errorResponse.error.error_description === 'invalid_argument') {
        this.globalMessageService.add("Due to some technical error we cannot proceed. Please try again later or call your KAM for assistance.",
          GlobalMessageType.MSG_TYPE_ERROR);
      } else if (errorResponse.error.error_description === 'User is disabled') {
        this.globalMessageService.add("The user is disabled. Contact your KAM.",
          GlobalMessageType.MSG_TYPE_ERROR);
      } else if (errorResponse.error.error_description === 'password_expired') {
        this.globalMessageService.add("For security reasons, you must renew your password using the Forgot my password link",
          GlobalMessageType.MSG_TYPE_ERROR);
      } else if (errorResponse.error.error_description === 'Your session has expired. Please login again.') {
        this.globalMessageService.add("Your session has expired. Please log in again.",
          GlobalMessageType.MSG_TYPE_ERROR);
      }  else if(errorResponse.error.error_description === "Invalid refresh token") {
          // window.location.replace(errorResponse.error.error_description);
          localStorage.clear();
          window.location.reload();
      } else {
        this.globalMessageService.add(
          errorResponse.error.error_description,
          GlobalMessageType.MSG_TYPE_ERROR
        );
      }
    }
  }
}
